<template>
    <div>
        <div class="profile-style">
            <h5 class="mb-4">Event Information</h5>
            <b-card class="bdr-15 card-style">
                <ValidationObserver ref="form">

                    <div class="form-group qr-wrapper">
                        <label>Event Package</label>
                        <div>
                            <template v-if="loading_package">
                                <b-spinner label="Loading..."></b-spinner>
                                <p>Update Event Package, please wait ...</p>
                            </template>
                            <template v-if="!loading_package">
                                <div class="premium-label" v-if="detail_event.type === 'PREMIUM'">{{detail_event.type}}</div>
                                <div class="standard-label mb-2" v-if="detail_event.type === 'STANDARD'">{{detail_event.type}}</div>
                                <a  v-if="detail_event.type === 'STANDARD'" href="#" @click.prevent="_upgradePackage()">Upgrade package event to premium </a>
                            </template>
                        </div>
                    </div>

                    <div class="form-group qr-wrapper position-relative">
                        <div v-if="detail_event.type === 'STANDARD'" class="disabled-feature bdr-15" @click.prevent="$emit('alertPackage')">
                            <i class="uil uil-lock-alt"></i>
                        </div>

                        <label :class="detail_event.type === 'STANDARD' ? 'pl-4 pt-3' : ''">Event QR Code</label>
                        <div v-if="detail_event.qrcode" :class="detail_event.type === 'STANDARD' ? 'pl-4 pb-3' : ''">
                            <div class="wrapper-img mb-2 position-relative">
                                <div v-if="detail_event.type === 'STANDARD'" class="disabled-qr"></div>
                                <img v-if="detail_event.type !== 'STANDARD'" width="100px" :src="'data:image/png;base64,' + detail_event.qrcode">
                            </div>
                            <button v-if="detail_event.type !== 'STANDARD'" @click.prevent="_downloadQrEvent(detail_event)" class="btn btn-outline-info">Download QRCode</button>
                        </div>

                        <div v-if="!detail_event.qrcode" :class="detail_event.type === 'STANDARD' ? 'pl-4 pb-3' : ''">
                            <template v-if="loading_qr">
                                <b-spinner label="Loading..."></b-spinner>
                                <p>Genereting QR Code, please wait ...</p>
                            </template>
                            <template v-if="!loading_qr">
                                <p class="mb-0">This event doesn't have a qrcode yet, create a qrcode now.</p>
                                <button @click.prevent="_generateQREvents()" v-bind:class="loading_qr ? 'btn-progress' : ''" class="btn btn-outline-info">Create QRCode</button>
                            </template>
                        </div >
                    </div>

                    <validation-provider rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Event Name</label>
                            <input v-model="detail_event.title" type="text" class="form-control" name="categories">
                            <div class="invalid-input">{{ errors[0] }}</div>
                        </div>
                    </validation-provider>

                    <validation-provider rules="required" v-slot="{ errors }">
                        <div class="form-group mb-3">
                            <label>Event Date</label>
                            <div class="input-group left">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="uil uil-calender"></i>
                                    </div>
                                </div>
                                <datetime v-model="detail_event.date_event" zone='local' value-zone='local' type="date" input-class="form-control"></datetime>
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </div>
                    </validation-provider>

                    <div class="form-group">
                        <label>Partner</label>
                        <select class="form-control" v-model="detail_event.partner_id">
                            <option selected></option>
                            <option v-for="data in partner" :key="data.id" :value="data.id">{{data.name}}</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>Category Event</label>
                        <input v-model="detail_event.category" type="text" class="form-control cat-input" name="categories">
                        <ul class="cat-list">
                            <li @click="detail_event.category = 'Wedding'">Wedding</li>
                            <li @click="detail_event.category = 'Birthday'">Birthday</li>
                            <li @click="detail_event.category = 'Mapandes'">Mapandes</li>
                            <li @click="detail_event.category = 'Wedding & Mapandes'">Wedding & Mapandes</li>
                            <li @click="detail_event.category = '3 Bulanan'">3 Bulanan</li>
                            <li @click="detail_event.category = 'Opening'">Opening</li>
                        </ul>
                    </div>

                    <div class="form-group">
                        <div class="mb-1">
                            <label>Music Theme</label>
                        </div>
                        <div v-if="detail_event.music_id == null" class="btn-up d-flex align-items-center" v-b-modal.modal-Music>
                            <div class="upload"><i class="uil uil-music mr-1"></i> CHOOSE MUSIC</div>
                        </div>

                        <div v-for="data in music" :key="data.id">
                            <template v-if="data.id === detail_event.music_id">
                                <button v-on:click.prevent="detail_event.music_id = null" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Music</button>
                                <div class="input-group img-sh">
                                    <div class="music-up d-flex">
                                        <div class="music-ic">
                                            <i class="w-100 uil uil-music mr-1"></i>
                                        </div>
                                        <div class="music-cnt ml-3 mt-1">
                                            <div><strong>{{data.title}}</strong></div>
                                            <div>{{data.size |formatSize}}</div>
                                            <div>{{data.type}}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="mb-1">
                            <label>Custom Guest Letter on Generate Guest Name</label>
                        </div>
                        <textarea class="form-control" v-model="detail_event.custom_guest_letter"></textarea>
                        <small>* fill in this text [link-undangan] in the text for automatic show invitation link</small>
                    </div>

                    <div class="text-right mt-3">
                        <button v-on:click="validationForm('basic')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                            Save Event
                        </button>
                    </div>

                </ValidationObserver>
            </b-card>
        </div>

        <div class="profile-style">
            <h5 class="mb-4">Color Setting</h5>
            <b-card class="bdr-15 card-style position-relative">
                <!-- <div v-if="detail_event.type === 'STANDARD'" class="disabled-feature bdr-15" @click.prevent="$emit('alertPackage')">
                    <i class="uil uil-lock-alt"></i>
                </div> -->
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Main Backgound Color</label>
                            <div class="input-group">
                                <input type="color" v-model="detail_event.main_bg" class="form-control color" name="categories">
                                <div v-if="detail_event.main_bg" class="input-group-append ga-color" @click="detail_event.main_bg = null">
                                    <div class="input-group-text">
                                        <i class="uil uil-multiply"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Second Backgound Color</label>
                            <div class="input-group">
                                <input type="color" v-model="detail_event.second_bg" class="form-control color" name="categories">
                                <div v-if="detail_event.second_bg" class="input-group-append ga-color" @click="detail_event.second_bg = null">
                                    <div class="input-group-text">
                                        <i class="uil uil-multiply"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Third Backgound Color</label>
                            <div class="input-group">
                                <input type="color" v-model="detail_event.third_bg" class="form-control color" name="categories">
                                <div v-if="detail_event.third_bg" class="input-group-append ga-color" @click="detail_event.third_bg = null">
                                    <div class="input-group-text">
                                        <i class="uil uil-multiply"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Main Text Color</label>
                            <div class="input-group">
                                <input type="color" v-model="detail_event.main_text" class="form-control color" name="categories">
                                <div v-if="detail_event.main_text" class="input-group-append ga-color" @click="detail_event.main_text = null">
                                    <div class="input-group-text">
                                        <i class="uil uil-multiply"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Second Text Color</label>
                            <div class="input-group">
                                <input type="color" v-model="detail_event.second_text" class="form-control color" name="categories">
                                <div v-if="detail_event.second_text" class="input-group-append ga-color" @click="detail_event.second_text = null">
                                    <div class="input-group-text">
                                        <i class="uil uil-multiply"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Third Text Color</label>
                            <div class="input-group">
                                <input type="color" v-model="detail_event.third_text" class="form-control color" name="categories">
                                <div v-if="detail_event.third_text" class="input-group-append ga-color" @click="detail_event.third_text = null">
                                    <div class="input-group-text">
                                        <i class="uil uil-multiply"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-right mt-3">
                    <button v-on:click="validationForm('color')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Event
                    </button>
                </div>

            </b-card>
        </div>

        <div class="profile-style">
            <h5 class="mb-4">Wording Style</h5>
            <b-card class="bdr-15 card-style position-relative">
                <!-- <div v-if="detail_event.type === 'STANDARD'" class="disabled-feature bdr-15" @click.prevent="$emit('alertPackage')">
                    <i class="uil uil-lock-alt"></i>
                </div> -->

                <div class="form-group mb-0">
                    <div class="row-style">
                        <div v-for="(data,index) in wording_list" :key="index"
                             @click="_changeWording(data.value)"
                             :class="detail_event.lang === data.value ? 'active' : ''"
                             class="style"
                            >
                                <div class="style-item style-img">
                                    <div class="style-tx">
                                        <span><i class="uil uil-text-fields"></i> {{data.name}}</span>
                                    </div>
                                </div>
                        </div>
                        <div class="style"></div>
                        <div class="style"></div>
                        <div class="style"></div>
                    </div>
                </div>

            </b-card>
        </div>

        <div class="profile-style rw-people">
            <h5 class="mb-4">Meta Information</h5>
            <b-card class="bdr-15 card-style">
                <ValidationObserver ref="form">

                    <validation-provider v-if="!detail_event.meta_image" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                        <div class="form-group">
                            <div class="mb-1">
                                <label>Meta Image</label>
                            </div>
                            <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                                <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                            </div>
                            <input ref="inputImage"
                                    type="file"
                                    class="custom-file-input d-none"
                                    id="Thumbnail"
                                    v-on:change="onMetaImageUpload"
                                    accept="image/jpeg,image/png,image/jpg"
                                    @input="validate" >

                            <div class="invalid-input mt-3">{{ errors[0] }}</div>
                        </div>
                    </validation-provider>

                    <div class="form-group" v-if="detail_event.meta_image">
                        <div class="mb-1">
                            <label>Meta Image</label>
                        </div>
                        <button v-on:click.prevent="removeMetaImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button>
                        <div class="input-group img-sh">
                            <img :src="detail_event.meta_image" class="img-responsive img-prf">
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Meta Title</label>
                        <input v-model="detail_event.meta_title" type="text" class="form-control" name="categories">
                    </div>

                    <div class="form-group">
                        <label>Meta Description</label>
                        <textarea v-model="detail_event.meta_desc" class="form-control"></textarea>
                    </div>

                    <div class="text-right mt-3">
                        <button v-on:click="validationForm('meta')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                            Save Event
                        </button>
                    </div>

                </ValidationObserver>
            </b-card>
        </div>

        <b-modal id="modal-Music" centered hide-footer title="Choose Music">
            <div class="form-group">
                <label>Search Music</label>
                <input type="text" @keyup="_filterMusics" v-model="searchmusic" class="form-control" name="name">
            </div>
            <ul class="list-unstyled list-unstyled-border">
                <li class="media mb-music" v-for="data in filteredMusic" :key="data.id" @click="chooseMusic(data.id)">
                    <div v-on:click.stop="" class="play-button mt-2 mb-2 mr-3" :class="[music_play === data.id ? 'active' : '']" @click="music_play === data.id ? pauseMusic(data) : playMusic(data)">
                        <i v-if="music_play !== data.id || music_pause && music_play === data.id" class="w-100 uil uil-play"></i>
                        <i v-if="music_play === data.id && !music_pause" class="w-100 uil uil-stop-circle"></i>
                    </div>
                    <div class="media-body">
                    <div class="media-title">{{data.title}}</div>
                    <div>{{data.size |formatSize}}</div>
                    <div>{{data.type}}</div>
                    </div>
                </li>
            </ul>

        </b-modal>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import { Datetime } from 'vue-datetime';

    export default{
        data(){
            return{
                loading:false,
                loading_qr:false,
                searchmusic:'',
                music_play:'',
                music_pause:false,
                music_set:new Audio(),
                meta_image_file:'',
                loading_package:false,
                wording_list:[{value:'ID',name:'Indonesia'},{value:'EN',name:'English'}]
            }
        },
        props:{
            detail_event:{
                type: Object,
                required: true,
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            Datetime,
        },
        computed:{
            ...mapState('EventsControl', {
                music: state => state.music,
                partner: state => state.partner,
            }),

            filteredMusic () {
                let filterMusic = this.$store.getters['EventsControl/getFilteredMusics'];
                return filterMusic
            },
        },
        filters: {
            formatSize: function(num){
                if (typeof num !== 'number' || isNaN(num)) {
                throw new TypeError('Expected a number');
                }

                var exponent;
                var unit;
                var neg = num < 0;
                var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                if (neg) {
                num = -num;
                }

                if (num < 1) {
                return (neg ? '-' : '') + num + ' B';
                }

                exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
                num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
                unit = units[exponent];

                return (neg ? '-' : '') + num + ' ' + unit;
            }
        },
        methods:{
            ...mapActions('EventsControl', ['detailEvents','filterMusics','updateBasicSetup','changeWording','generateQREvents','upgradePackage']),

            _filterMusics:function() {
                clearTimeout(this.timeout);

                var self = this;
                this.timeout = setTimeout(function () {
                    self.$store.dispatch('EventsControl/filterMusics', self.searchmusic )
                }, 500);
            },
            onMetaImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.detail_event.meta_image = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.meta_image_file = input.files[0]
            },
            removeMetaImageUpload:function(){
                this.meta_image_file = ''
                this.detail_event.meta_image = ''
            },
            playMusic: function(data){
                if(!this.music_set.paused){
                    this.music_set.pause();
                    this.music_set.currentTime = 0;
                    this.music_play = data.id
                    this.music_set = new Audio(data.url);
                    this.music_set.play()
                }else{
                    this.music_play = data.id
                    this.music_set = new Audio(data.url);
                    this.music_set.play()
                }
            },
            pauseMusic: function(){
                if(!this.music_set.paused){
                    this.music_pause = true
                    this.music_set.pause()
                }else{
                    this.music_pause = false
                    this.music_set.play()
                }
            },
            chooseMusic: function(id){
                this.detail_event.music_id = id
                this.$bvModal.hide('modal-Music')
            },
            validationForm: function(type) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();

                        if(type == 'basic'){

                            formData.append('title', this.detail_event.title);
                            formData.append('qrcode', this.detail_event.qrcode);
                            formData.append('category', this.detail_event.category ? this.detail_event.category : '');
                            formData.append('date_event', this.detail_event.date_event);
                            formData.append('partner_id', this.detail_event.partner_id);
                            formData.append('custom_guest_letter', this.detail_event.custom_guest_letter ? this.detail_event.custom_guest_letter : '');
                            formData.append('music_id', this.detail_event.music_id ? this.detail_event.music_id : '');

                        }else if(type == 'color'){

                            formData.append("main_bg", this.detail_event.main_bg ? this.detail_event.main_bg : '');
                            formData.append("second_bg", this.detail_event.second_bg ? this.detail_event.second_bg : '');
                            formData.append("third_bg", this.detail_event.third_bg ? this.detail_event.third_bg : '');
                            formData.append("main_text", this.detail_event.main_text ? this.detail_event.main_text : '');
                            formData.append("second_text", this.detail_event.second_text ? this.detail_event.second_text : '');
                            formData.append("third_text", this.detail_event.third_text ? this.detail_event.third_text : '');

                        }else if(type == 'meta'){

                            formData.append('meta_title', this.detail_event.meta_title);
                            formData.append('meta_desc', this.detail_event.meta_desc);
                            formData.append('meta_image', this.detail_event.meta_image ? this.detail_event.meta_image : '');
                            formData.append('meta_image_file', this.meta_image_file);

                        }
                        formData.append("_method", "put");
                        formData.append("type", type);

                        this.updateBasicSetup(formData).then(() => {
                            this.loading = false
                            this.detailEvents(this.$route.params.id)
                            this.$toast.success('Successfully Update Event')
                        }).catch((error) => {
                            console.log(error)
                            this.loading = false
                            this.$toast.success('Sorry, Something Error')
                        })

                    }
                });
            },
            _generateQREvents:function(){
                this.loading_qr = true
                this.generateQREvents().then(() => {
                    this.$toast.success('Successfully Generate QR Code')
                    this.detailEvents(this.$route.params.id).then(() => {
                        this.loading_qr = false
                    })
                }).catch((error) => {
                    console.log(error)
                    this.loading = false
                    this.$toast.success('Sorry, Something Error')
                })
            },
            _downloadQrEvent:function(event){
                var a = document.createElement("a");
                a.href = "data:image/png;base64," + event.qrcode;
                a.download = "qrcode-" + event.id + '-' + event.title + '.png';
                a.click();
            },
            _changeWording: function(lang){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you to change wording in your event ? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.changeWording(lang).then(
                            this.$toast.success('Successfully Change Wording Event'),
                            this.detailEvents(this.$route.params.id)
                        )
                    }
                })
            },
            _upgradePackage: function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you to upgrade event package to premium ? This action will take 1 slot and this action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.loading_package = true
                        this.upgradePackage().then(() => {
                            this.$toast.success('Successfully Upgrade Event Package'),
                            this.detailEvents(this.$route.params.id).then(
                                this.loading_package = false
                            )
                        }).catch((error) => {
                            this.loading_package = false
                            if(error.response.data.errors == 'slot'){
                                this.$toast.warning('Your slots are not enough')
                            }else{
                                this.$toast.warning('Sorry, Something Error')
                            }
                        })
                    }
                })
            },
        }
    }

</script>
